<div class="kanban-filters">
  @for (filter of displayFilters(); track filterKey(filter)) {
    <div class="filter-item">
      @switch (filter.type) {
        @case ('check') {
          <visio-filter-chip
            [selected]="selectedValues()[filterKey(filter)] === filter.value"
            (click)="toggleFilterValue(filterKey(filter), filter.value)"
            >{{ filter.label }}</visio-filter-chip
          >
        }
        @case ('select') {
          <div class="combobox-clearable">
            <visio-combobox
              [items]="filter.options"
              [label]="filter.label"
              [ngModel]="selectedValues()[filterKey(filter)]"
              (selectionChange)="toggleFilterValue(filterKey(filter), $event.value)"
            ></visio-combobox>
            @if (selectedValues()[filterKey(filter)]) {
              <visio-icon-button
                icon="clear-icon"
                (click)="updateFilterValue(filterKey(filter), null)"
              ></visio-icon-button>
            }
          </div>
        }
        @case ('date') {
          <div class="combobox-clearable">
            <visio-date-picker
              [placeholder]="filter.label"
              [selectedDate]="dateValues()[filterKey(filter)]"
              [range]="true"
              (change)="onDateChange(filter, $event)"
            ></visio-date-picker>
            @if (selectedValues()[filterKey(filter)]) {
              <visio-icon-button
                icon="clear-icon"
                (click)="updateFilterValue(filterKey(filter), null)"
              ></visio-icon-button>
            }
          </div>
        }
        @case ('text') {
          <visio-input
            [placeholder]="filter.placeholder ?? filter.label"
            (ngModelChange)="onTextChange(filter, $event)"
            [ngModel]="selectedValues()[filterKey(filter)] ?? ''"
          ></visio-input>
        }
        @case ('property') {
          <app-kanban-property-filter
            [filter]="filter"
            [value]="selectedValues()[filterKey(filter)]"
            (valueChange)="updateFilterValue(filterKey(filter), $event)"
          />
        }
        @case ('multiselect') {
          <visio-multi-select
            [options]="multiselectOptions().get(filterKey(filter)) ?? []"
            [placeholder]="filter.label"
            [ngModel]="multiselectSelectedValues().get(filterKey(filter)) ?? []"
            (changeSelected)="onMultiSelectChange(filterKey(filter), $event)"
          ></visio-multi-select>
        }
      }
    </div>
  }

  @for (chip of advancedFilterChips(); track chip.fieldId) {
    <visio-filter-chip [selected]="true" [close]="true" (close)="onAdvancedClear(chip.fieldId)">{{
      chip.label
    }}</visio-filter-chip>
  }

  @if (showAdvancedFilters() && boardFields().length > 0) {
    <div class="advanced-filters-wrapper">
      <visio-button #advancedBtn (click)="toggleAdvancedPanel()">
        Filtros avançados
        @if (advancedFilterChips().length > 0) {
          <span class="advanced-filters-trigger__count">{{ advancedFilterChips().length }}</span>
        }
      </visio-button>
      @if (showAdvancedPanel()) {
        <app-kanban-filters-panel
          [boardFields]="boardFields()"
          [appliedFilters]="advancedFilters()"
          [position]="panelPosition()"
          [users]="usersByField()"
          (apply)="onAdvancedApply($event)"
        ></app-kanban-filters-panel>
      }
    </div>
  }
</div>
